import styled from "styled-components";

export const FooterContainer = styled.footer`
  background-color: var(--gray-color);
  padding: 4rem 4rem 1rem;
  margin-top: 10rem;
  
  @media (max-width: 992px) {
    padding: 2rem 1rem 1rem;
  }
`;

export const FooterLinkTitle = styled.h2`
  font-size: 1.3rem;
  color: #F0F3F8;
  margin-bottom: 1.8rem;

  @media (max-width: 992px) {
    margin-bottom: 3rem;
  }
`;

export const FooterLinks = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  li {
    margin-bottom: .8rem;
  }

  a {
    color: #E1E5EC;
    transition: .3s;

    &:hover {
      color: #d5d9e0;
    }
  }
  
  @media (max-width: 992px) {
    li {
      margin-bottom: 2rem;
    }
  }
  
`;

export const FooterMainRow = styled.div`
  &:after {
    content: '';
    display: inline-block;
    width: calc(80% - 1rem);
    height: 2px;
    background-color: rgba(255, 255, 255, 0.3);
    position: relative;
    right: calc(10% - 1rem);
    margin-top: 2rem;
  }

  @media (max-width: 992px) {
    &:after {
      width: calc(85%);
      margin-right: auto;
      margin-left: auto;
      right: unset;
    }
  }
`;

export const PolicyText = styled.p`
  color: #B5BDCA;
`;
